export const careerConstants = {
    CAREER_DETAILS_REQUEST: "CAREER_DETAILS_REQUEST",
    CAREER_DETAILS_SUCCESS: "CAREER_DETAILS_SUCCESS",
    CAREER_DETAILS_FAILURE: "CAREER_DETAILS_FAILURE",
   
  };
  